/**
 * ReceivedInvites — invites waiting for me, with Join / No thanks (§ F208).
 * Shown on My Groups and in the pop-up that greets a signed-in player who has
 * invites (`GroupsChip`).
 */

import { useState } from "react";
import { answerInvite, invitesChanged, type GroupInvite } from "../lib/account";

const SMALL_BTN =
  "shrink-0 min-h-[44px] px-3 ink-border rounded-block font-heading font-extrabold uppercase tracking-wide text-xs btn-press btn-off inline-flex items-center justify-center gap-1.5";

export function ReceivedInvites({ invites, onAnswered }: { invites: GroupInvite[]; onAnswered: () => void }) {
  const [error, setError] = useState("");
  if (invites.length === 0) return null;
  const answer = async (id: string, accept: boolean) => {
    setError("");
    try {
      await answerInvite(id, accept);
      invitesChanged();
      onAnswered();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  return (
    <div data-testid="groups-invites" className="bg-brand-primary ink-border rounded-block-lg block-shadow-1 p-3 flex flex-col gap-2">
      <p className="font-heading font-extrabold uppercase tracking-wide text-xs">Invites for you</p>
      {invites.map((inv) => (
        <div key={inv.id} data-testid="groups-invite" className="bg-white ink-border rounded-block p-2 flex flex-col gap-2">
          <p className="text-sm">
            <strong>{inv.invited_by ?? "Someone"}</strong> invited you to <strong>{inv.group_name}</strong> (
            {inv.member_count} {inv.member_count === 1 ? "player" : "players"}).
          </p>
          <div className="flex gap-2">
            <button type="button" data-testid="groups-invite-accept" onClick={() => void answer(inv.id, true)} className={`${SMALL_BTN} flex-1 bg-black text-white`}>
              Join
            </button>
            <button type="button" data-testid="groups-invite-decline" onClick={() => void answer(inv.id, false)} className={`${SMALL_BTN} flex-1 bg-white`}>
              No thanks
            </button>
          </div>
        </div>
      ))}
      {error && <p className="text-xs font-bold">{error}</p>}
    </div>
  );
}

